import React from 'react';
import { space } from 'styled-system';
import styled from '../../../libs/styled.es.js';
import { SvgIcon } from '../SvgIcon/SvgIcon.es.js';
import { theme } from '../../../configs/theme.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBackground = (props) => {
  if (props.link)
    return "transparent";
  if (props.outline)
    return props.theme.colors.white;
  return props.disabled ? `${props.theme.colors.gray400} !important` : props.variant === "primary" ? props.theme.brand.primary : props.variant === "secondary" ? props.theme.brand.secondary : props.variant === "tertiary" ? props.theme.brand.tertiary : props.variant === "normal" ? props.theme.colors.gray300 : props.variant === "danger" ? props.theme.colors.red : props.variant === "disabled" ? `${props.theme.colors.gray400} !important` : props.theme.colors.gray200;
};
const getColor = (props) => {
  if (props.variant === "tertiary")
    return props.theme.colors.text;
  if (props.tag && !props.outline && !props.link)
    return props.theme.colors.white + "!important";
  if (props.outline || props.link) {
    return props.variant === "primary" ? props.theme.brand.primary : props.variant === "secondary" ? props.theme.brand.secondary : props.variant === "danger" ? props.theme.colors.red : props.variant === "disabled" ? `${props.theme.colors.gray600} !important` : props.theme.colors.text;
  }
  if (props.disabled)
    return `${theme.colors.gray600} !important`;
  return props.variant && props.variant !== "normal" && !props.link ? theme.colors.white : theme.colors.gray900;
};
const StyledButton = styled.button((props) => {
  return `
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    ${props.size === "lg" ? `
        line-height: 1.5;
        padding: .5rem 1rem;` : `
        line-height: 1rem;
        padding: .365rem .75rem;`}
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${getBackground(props)};
    border-color: ${props.outline ? getColor(props) : getBackground(props)};
    color: ${getColor(props)};
    border-width: 1px;
    border-style: solid;
    user-select: none;
    text-decoration: none;
    flex-direction: ${props.flexDirection};
    position: relative;
    ${props.block ? `width: 100%;` : ""}
    ${props.disabled && "pointer-events: none;"}
    &:focus {
      outline: 0;
    }
    `;
}, space);
const Spacer = styled.div`
  width: 0.4rem;
  height: 0.4rem;
`;
const LoadingWrapper = styled.div((props) => `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${getBackground(props)};
  .pulse {
    position: relative;
  left: -9999px;
  width: 4px;
  height: 4px;
  border-radius: 5px;
  background-color: ${getColor(props)};
  color: ${getColor(props)};
  box-shadow: 9999px 0 0 -5px ${getColor(props)};
  animation: dot-pulse 1.5s infinite linear;
  animation-delay: 0.25s;

  &:before,
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${getColor(props)};
    color: ${getColor(props)};
  }
  &:before {
    box-shadow: 9988px 0 0 -5px ${getColor(props)};
    animation: dot-pulse-before 1.5s infinite linear;
    animation-delay: 0s;
  }
  &:after {
    box-shadow: 10010px 0 0 -5px ${getColor(props)};
    animation: dot-pulse-after 1.5s infinite linear;
    animation-delay: 0.5s;
  }
  @keyframes dot-pulse-before {
    0% {
      box-shadow: 9988px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 9988px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 9988px 0 0 -5px ${getColor(props)};
    }
  }

  @keyframes dot-pulse {
    0% {
      box-shadow: 9999px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 9999px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 9999px 0 0 -5px ${getColor(props)};
    }
  }

  @keyframes dot-pulse-after {
    0% {
      box-shadow: 10010px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 10010px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 10010px 0 0 -5px ${getColor(props)};
    }
  }
  }
`);
const StyledLink = StyledButton.withComponent("a");
const Button = React.forwardRef((props, ref) => {
  const _a = props, {
    outline,
    variant,
    children,
    block,
    tag,
    icon,
    disabled,
    flexDirection = "row",
    loading,
    onClick
  } = _a, others = __objRest(_a, [
    "outline",
    "variant",
    "children",
    "block",
    "tag",
    "icon",
    "disabled",
    "flexDirection",
    "loading",
    "onClick"
  ]);
  const ButtonTag = tag === "a" ? StyledLink : StyledButton;
  return /* @__PURE__ */ React.createElement(ButtonTag, __spreadValues({
    ref,
    block,
    variant,
    outline,
    flexDirection,
    disabled,
    tag,
    onClick: loading ? void 0 : onClick
  }, others), icon && /* @__PURE__ */ React.createElement(SvgIcon, __spreadValues({}, icon)), icon && children && /* @__PURE__ */ React.createElement(Spacer, {
    className: "spacer"
  }), children, loading && /* @__PURE__ */ React.createElement(LoadingWrapper, {
    variant,
    outline
  }, /* @__PURE__ */ React.createElement("div", {
    className: "pulse"
  })));
});
Button.displayName = "Button";

export { Button };
